export default __webpack_public_path__ + "static/sac2.inspirations-bfe21aa13ece4de588df1f0a39abd014.jpg";